// extracted by mini-css-extract-plugin
module.exports = {"gradient":"Animation_gradient__7wAyH"};